{
  "defaultMessages.ACTIVE_DUTY": "現役軍人",
  "defaultMessages.ARCHITECT": "建築師",
  "defaultMessages.CHILD_CARE_WORKER": "托育服務人員",
  "defaultMessages.COMMUNITY_ELIGIBILITY_PROVISION": "CEP（社區資格條款，標題1/LAP）",
  "defaultMessages.DENTIST": "牙科醫生",
  "defaultMessages.DOCTOR": "醫生",
  "defaultMessages.EMT": "急救醫療技術員",
  "defaultMessages.FIREFIGHTER": "消防員",
  "defaultMessages.GENERAL_CONTRACTOR": "總承判商",
  "defaultMessages.GOLD_STAR_FAMILY": "金星家庭",
  "defaultMessages.GRADUATE": "畢業生",
  "defaultMessages.HOME_BUYER": "置業人士",
  "defaultMessages.INTERIOR_DESIGNER": "室內設計師",
  "defaultMessages.LIBRARIAN": "圖書館員",
  "defaultMessages.LICENSED_COSMETOLOGIST": "持牌美容師",
  "defaultMessages.LICENSED_REAL_ESTATE_AGENT": "持牌地產代理",
  "defaultMessages.MILITARY_FAMILY": "軍人家屬",
  "defaultMessages.MILITARY_RETIREE": "軍隊退休人員",
  "defaultMessages.NURSE": "護士",
  "defaultMessages.NUTRITION_PROFESSIONAL": "營養專業人員",
  "defaultMessages.OTHER_GOVERNMENT_ASSISTANCE": "其他政府援助受益人",
  "defaultMessages.OTHER_HEALTH_WORKER": "其他醫療工作者",
  "defaultMessages.OTHER_MOVER": "其他搬運人員",
  "defaultMessages.PHARMACIST": "藥劑師",
  "defaultMessages.POLICE": "警察",
  "defaultMessages.RESERVIST": "後備役或國民警衛隊",
  "defaultMessages.SEARCH_AND_RESCUE": "搜救人員",
  "defaultMessages.SNAP_BENEFITS": "SNAP福利受益人",
  "defaultMessages.STUDENT": "學生",
  "defaultMessages.VETERAN": "退伍軍人或軍隊退休人員",
  "defaultMessages.VETERINARIAN": "獸醫",
  "defaultMessages._EXPERIMENTAL.cvecNumberExplanation": "新增您的CVEC號碼以提高即時驗證的成功率。",
  "defaultMessages.activeDutyStartDate": "現役開始日期",
  "defaultMessages.address": "地址",
  "defaultMessages.addressPlaceholder": "地址",
  "defaultMessages.birthDate": "出生日期",
  "defaultMessages.branchOfService": "服役軍種",
  "defaultMessages.branchOfServicePlaceholder": "服役軍種",
  "defaultMessages.cantFindYourSchool": "找不到您的學校？點擊查看提示",
  "defaultMessages.captchaFooterText": "Cloudflare將獨立收集您的資料，用於與驗證相關的防欺詐目的，並依據其<cloudflarePrivacyPolicy>私隱政策</cloudflarePrivacyPolicy>使用相關資料。",
  "defaultMessages.changeLanguage": "更改語言",
  "defaultMessages.chooseCountry": "請在搜尋前選擇國家／地區",
  "defaultMessages.city": "城市",
  "defaultMessages.cityPlaceholder": "城市",
  "defaultMessages.clearAndOpenMenu": "清除選擇並開啟選單",
  "defaultMessages.clearSelection": "清除選擇",
  "defaultMessages.close": "關閉",
  "defaultMessages.closeSection": "關閉部分",
  "defaultMessages.company": "公司",
  "defaultMessages.companyPlaceholder": "公司",
  "defaultMessages.copied": "已複製",
  "defaultMessages.countries.AD": "安道爾",
  "defaultMessages.countries.AE": "阿拉伯聯合酋長國",
  "defaultMessages.countries.AF": "阿富汗",
  "defaultMessages.countries.AG": "安提瓜和巴布達",
  "defaultMessages.countries.AI": "安圭拉",
  "defaultMessages.countries.AL": "阿爾巴尼亞",
  "defaultMessages.countries.AM": "亞美尼亞",
  "defaultMessages.countries.AN": "荷屬安的列斯",
  "defaultMessages.countries.AO": "安哥拉",
  "defaultMessages.countries.AR": "阿根廷",
  "defaultMessages.countries.AS": "美屬薩摩亞",
  "defaultMessages.countries.AT": "奧地利",
  "defaultMessages.countries.AU": "澳洲",
  "defaultMessages.countries.AW": "阿魯巴",
  "defaultMessages.countries.AZ": "阿塞拜疆",
  "defaultMessages.countries.BA": "波斯尼亞和黑塞哥維那",
  "defaultMessages.countries.BB": "巴巴多斯",
  "defaultMessages.countries.BD": "孟加拉",
  "defaultMessages.countries.BE": "比利時",
  "defaultMessages.countries.BF": "布基納法索",
  "defaultMessages.countries.BG": "保加利亞",
  "defaultMessages.countries.BH": "巴林",
  "defaultMessages.countries.BI": "布隆迪",
  "defaultMessages.countries.BJ": "貝寧",
  "defaultMessages.countries.BM": "百慕大",
  "defaultMessages.countries.BN": "汶萊",
  "defaultMessages.countries.BO": "玻利維亞",
  "defaultMessages.countries.BR": "巴西",
  "defaultMessages.countries.BS": "巴哈馬",
  "defaultMessages.countries.BT": "不丹",
  "defaultMessages.countries.BV": "布韋島",
  "defaultMessages.countries.BW": "博茨瓦納",
  "defaultMessages.countries.BY": "白俄羅斯",
  "defaultMessages.countries.BZ": "伯利茲",
  "defaultMessages.countries.CA": "加拿大",
  "defaultMessages.countries.CD": "剛果民主共和國",
  "defaultMessages.countries.CF": "中非共和國",
  "defaultMessages.countries.CG": "剛果共和國",
  "defaultMessages.countries.CH": "瑞士",
  "defaultMessages.countries.CI": "科特迪瓦",
  "defaultMessages.countries.CK": "庫克群島",
  "defaultMessages.countries.CL": "智利",
  "defaultMessages.countries.CM": "喀麥隆",
  "defaultMessages.countries.CN": "中國",
  "defaultMessages.countries.CO": "哥倫比亞",
  "defaultMessages.countries.CR": "哥斯達黎加",
  "defaultMessages.countries.CU": "古巴",
  "defaultMessages.countries.CV": "佛得角",
  "defaultMessages.countries.CW": "庫拉索",
  "defaultMessages.countries.CY": "塞浦路斯",
  "defaultMessages.countries.CZ": "捷克共和國",
  "defaultMessages.countries.DE": "德國",
  "defaultMessages.countries.DJ": "吉布提",
  "defaultMessages.countries.DK": "丹麥",
  "defaultMessages.countries.DM": "多米尼克",
  "defaultMessages.countries.DO": "多明尼加共和國",
  "defaultMessages.countries.DZ": "阿爾及利亞",
  "defaultMessages.countries.EC": "厄瓜多爾",
  "defaultMessages.countries.EE": "愛沙尼亞",
  "defaultMessages.countries.EG": "埃及",
  "defaultMessages.countries.EH": "西撒哈拉",
  "defaultMessages.countries.ER": "厄立特里亞",
  "defaultMessages.countries.ES": "西班牙",
  "defaultMessages.countries.ET": "埃塞俄比亞",
  "defaultMessages.countries.FI": "芬蘭",
  "defaultMessages.countries.FJ": "斐濟",
  "defaultMessages.countries.FK": "福克蘭群島",
  "defaultMessages.countries.FM": "密克羅尼西亞",
  "defaultMessages.countries.FO": "法羅群島",
  "defaultMessages.countries.FR": "法國",
  "defaultMessages.countries.GA": "加蓬",
  "defaultMessages.countries.GB": "英國",
  "defaultMessages.countries.GD": "格林納達",
  "defaultMessages.countries.GE": "格魯吉亞",
  "defaultMessages.countries.GF": "法屬圭亞那",
  "defaultMessages.countries.GH": "加納",
  "defaultMessages.countries.GI": "直布羅陀",
  "defaultMessages.countries.GL": "格陵蘭",
  "defaultMessages.countries.GM": "岡比亞",
  "defaultMessages.countries.GN": "幾內亞",
  "defaultMessages.countries.GP": "瓜德羅普（法屬）",
  "defaultMessages.countries.GQ": "赤道幾內亞",
  "defaultMessages.countries.GR": "希臘",
  "defaultMessages.countries.GS": "南喬治亞和南桑威奇群島",
  "defaultMessages.countries.GT": "危地馬拉",
  "defaultMessages.countries.GU": "關島（美國）",
  "defaultMessages.countries.GW": "幾內亞比紹",
  "defaultMessages.countries.GY": "圭亞那",
  "defaultMessages.countries.HK": "香港",
  "defaultMessages.countries.HM": "赫德島和麥克唐納群島",
  "defaultMessages.countries.HN": "洪都拉斯",
  "defaultMessages.countries.HR": "克羅地亞",
  "defaultMessages.countries.HT": "海地",
  "defaultMessages.countries.HU": "匈牙利",
  "defaultMessages.countries.ID": "印度尼西亞",
  "defaultMessages.countries.IE": "愛爾蘭",
  "defaultMessages.countries.IL": "以色列",
  "defaultMessages.countries.IN": "印度",
  "defaultMessages.countries.IO": "英屬印度洋領地",
  "defaultMessages.countries.IQ": "伊拉克",
  "defaultMessages.countries.IR": "伊朗",
  "defaultMessages.countries.IS": "冰島",
  "defaultMessages.countries.IT": "意大利",
  "defaultMessages.countries.JM": "牙買加",
  "defaultMessages.countries.JO": "約旦",
  "defaultMessages.countries.JP": "日本",
  "defaultMessages.countries.KE": "肯尼亞",
  "defaultMessages.countries.KG": "吉爾吉斯斯坦",
  "defaultMessages.countries.KH": "柬埔寨",
  "defaultMessages.countries.KI": "基里巴斯",
  "defaultMessages.countries.KM": "科摩羅",
  "defaultMessages.countries.KN": "聖基茨和尼維斯",
  "defaultMessages.countries.KP": "北韓",
  "defaultMessages.countries.KR": "南韓",
  "defaultMessages.countries.KW": "科威特",
  "defaultMessages.countries.KY": "開曼群島",
  "defaultMessages.countries.KZ": "哈薩克斯坦",
  "defaultMessages.countries.LA": "老撾",
  "defaultMessages.countries.LB": "黎巴嫩",
  "defaultMessages.countries.LC": "聖盧西亞",
  "defaultMessages.countries.LI": "列支敦士登",
  "defaultMessages.countries.LK": "斯里蘭卡",
  "defaultMessages.countries.LR": "利比里亞",
  "defaultMessages.countries.LS": "萊索托",
  "defaultMessages.countries.LT": "立陶宛",
  "defaultMessages.countries.LU": "盧森堡",
  "defaultMessages.countries.LV": "拉脫維亞",
  "defaultMessages.countries.LY": "利比亞",
  "defaultMessages.countries.MA": "摩洛哥",
  "defaultMessages.countries.MC": "摩納哥",
  "defaultMessages.countries.MD": "摩爾多瓦",
  "defaultMessages.countries.ME": "黑山",
  "defaultMessages.countries.MG": "馬達加斯加",
  "defaultMessages.countries.MH": "馬紹爾群島",
  "defaultMessages.countries.MK": "馬其頓",
  "defaultMessages.countries.ML": "馬里",
  "defaultMessages.countries.MM": "緬甸",
  "defaultMessages.countries.MN": "蒙古",
  "defaultMessages.countries.MO": "澳門",
  "defaultMessages.countries.MP": "北馬里亞納群島",
  "defaultMessages.countries.MQ": "馬提尼克（法屬）",
  "defaultMessages.countries.MR": "毛里塔尼亞",
  "defaultMessages.countries.MS": "蒙特塞拉特",
  "defaultMessages.countries.MT": "馬耳他",
  "defaultMessages.countries.MU": "毛里求斯",
  "defaultMessages.countries.MV": "馬爾代夫",
  "defaultMessages.countries.MW": "馬拉維",
  "defaultMessages.countries.MX": "墨西哥",
  "defaultMessages.countries.MY": "馬來西亞",
  "defaultMessages.countries.MZ": "莫桑比克",
  "defaultMessages.countries.NA": "納米比亞",
  "defaultMessages.countries.NC": "新喀里多尼亞（法屬）",
  "defaultMessages.countries.NE": "尼日爾",
  "defaultMessages.countries.NF": "諾福克島",
  "defaultMessages.countries.NG": "尼日利亞",
  "defaultMessages.countries.NI": "尼加拉瓜",
  "defaultMessages.countries.NL": "荷蘭",
  "defaultMessages.countries.NO": "挪威",
  "defaultMessages.countries.NP": "尼泊爾",
  "defaultMessages.countries.NR": "瑙魯",
  "defaultMessages.countries.NU": "紐埃",
  "defaultMessages.countries.NZ": "紐西蘭",
  "defaultMessages.countries.OM": "阿曼",
  "defaultMessages.countries.PA": "巴拿馬",
  "defaultMessages.countries.PE": "秘魯",
  "defaultMessages.countries.PF": "法屬玻里尼西亞",
  "defaultMessages.countries.PG": "巴布亞新幾內亞",
  "defaultMessages.countries.PH": "菲律賓",
  "defaultMessages.countries.PK": "巴基斯坦",
  "defaultMessages.countries.PL": "波蘭",
  "defaultMessages.countries.PM": "聖皮埃爾和密克隆",
  "defaultMessages.countries.PN": "皮特凱恩島",
  "defaultMessages.countries.PR": "波多黎各",
  "defaultMessages.countries.PS": "巴勒斯坦",
  "defaultMessages.countries.PT": "葡萄牙",
  "defaultMessages.countries.PW": "帛琉",
  "defaultMessages.countries.PY": "巴拉圭",
  "defaultMessages.countries.QA": "卡塔爾",
  "defaultMessages.countries.RE": "留尼旺（法屬）",
  "defaultMessages.countries.RO": "羅馬尼亞",
  "defaultMessages.countries.RS": "塞爾維亞",
  "defaultMessages.countries.RU": "俄羅斯聯邦",
  "defaultMessages.countries.RW": "盧旺達",
  "defaultMessages.countries.SA": "沙特阿拉伯",
  "defaultMessages.countries.SB": "所羅門群島",
  "defaultMessages.countries.SC": "塞舌爾",
  "defaultMessages.countries.SD": "蘇丹",
  "defaultMessages.countries.SE": "瑞典",
  "defaultMessages.countries.SG": "新加坡",
  "defaultMessages.countries.SH": "聖赫勒拿",
  "defaultMessages.countries.SI": "斯洛文尼亞",
  "defaultMessages.countries.SK": "斯洛伐克共和國",
  "defaultMessages.countries.SL": "塞拉利昂",
  "defaultMessages.countries.SM": "聖馬力諾",
  "defaultMessages.countries.SN": "塞內加爾",
  "defaultMessages.countries.SO": "索馬里",
  "defaultMessages.countries.SR": "蘇里南",
  "defaultMessages.countries.SS": "南蘇丹",
  "defaultMessages.countries.ST": "聖多美和普林西比",
  "defaultMessages.countries.SV": "薩爾瓦多",
  "defaultMessages.countries.SY": "敘利亞",
  "defaultMessages.countries.SZ": "斯威士蘭",
  "defaultMessages.countries.TC": "特克斯和凱科斯群島",
  "defaultMessages.countries.TD": "乍得",
  "defaultMessages.countries.TF": "法屬南部領地",
  "defaultMessages.countries.TG": "多哥",
  "defaultMessages.countries.TH": "泰國",
  "defaultMessages.countries.TJ": "塔吉克斯坦",
  "defaultMessages.countries.TK": "托克勞",
  "defaultMessages.countries.TL": "東帝汶",
  "defaultMessages.countries.TM": "土庫曼斯坦",
  "defaultMessages.countries.TN": "突尼斯",
  "defaultMessages.countries.TO": "湯加",
  "defaultMessages.countries.TR": "土耳其",
  "defaultMessages.countries.TT": "千里達和多巴哥",
  "defaultMessages.countries.TV": "圖瓦盧",
  "defaultMessages.countries.TW": "台灣",
  "defaultMessages.countries.TZ": "坦桑尼亞",
  "defaultMessages.countries.UA": "烏克蘭",
  "defaultMessages.countries.UG": "烏干達",
  "defaultMessages.countries.UM": "美國本土外小島嶼",
  "defaultMessages.countries.US": "美國",
  "defaultMessages.countries.UY": "烏拉圭",
  "defaultMessages.countries.UZ": "烏茲別克斯坦",
  "defaultMessages.countries.VA": "梵蒂岡城國",
  "defaultMessages.countries.VC": "聖文森特和格林納丁斯",
  "defaultMessages.countries.VE": "委內瑞拉",
  "defaultMessages.countries.VG": "英屬維爾京群島",
  "defaultMessages.countries.VI": "美屬維爾京群島",
  "defaultMessages.countries.VN": "越南",
  "defaultMessages.countries.VU": "瓦努阿圖",
  "defaultMessages.countries.WF": "瓦利斯和富圖納群島",
  "defaultMessages.countries.WS": "薩摩亞",
  "defaultMessages.countries.XK": "科索沃",
  "defaultMessages.countries.YE": "也門",
  "defaultMessages.countries.YT": "馬約特",
  "defaultMessages.countries.ZA": "南非",
  "defaultMessages.countries.ZM": "贊比亞",
  "defaultMessages.countries.ZW": "津巴布韋",
  "defaultMessages.country": "國家",
  "defaultMessages.countryPlaceholder": "國家",
  "defaultMessages.cvecNumber": "CVEC證書編號",
  "defaultMessages.cvecNumberExplanation": "可選 - 新增您的CVEC編號可提高即時驗證的成功率。",
  "defaultMessages.dateTime.20_MIN": "20分鐘",
  "defaultMessages.dateTime.24_HRS": "24小時",
  "defaultMessages.dateTime.2_DAY": "2天",
  "defaultMessages.dateTime.2_HRS": "2小時",
  "defaultMessages.dateTime.2_MIN": "2分鐘",
  "defaultMessages.dateTime.3_DAY": "3天",
  "defaultMessages.dateTime.A_FEW_DAYS": "幾天",
  "defaultMessages.dateTime.A_FEW_HOURS": "幾個小時",
  "defaultMessages.dateTime.A_FEW_MINUTES": "幾分鐘",
  "defaultMessages.dateTime.A_HALF_HOUR": "半小時",
  "defaultMessages.dateTime.april": "四月",
  "defaultMessages.dateTime.august": "八月",
  "defaultMessages.dateTime.day": "日",
  "defaultMessages.dateTime.december": "十二月",
  "defaultMessages.dateTime.february": "二月",
  "defaultMessages.dateTime.january": "一月",
  "defaultMessages.dateTime.july": "七月",
  "defaultMessages.dateTime.june": "六月",
  "defaultMessages.dateTime.march": "三月",
  "defaultMessages.dateTime.may": "五月",
  "defaultMessages.dateTime.month": "月",
  "defaultMessages.dateTime.november": "十一月",
  "defaultMessages.dateTime.october": "十月",
  "defaultMessages.dateTime.september": "九月",
  "defaultMessages.dateTime.year": "年",
  "defaultMessages.dischargeDate": "退役日期",
  "defaultMessages.driverLicenseNumber": "駕駛執照號碼",
  "defaultMessages.driverLicenseNumberPlaceholder": "駕駛執照號碼",
  "defaultMessages.driverLicenseState": "駕駛執照發證州",
  "defaultMessages.ebtCardNumber": "EBT卡號碼",
  "defaultMessages.emailAddress": "電郵地址",
  "defaultMessages.emailAddressPlaceholder": "電郵地址",
  "defaultMessages.error": "我們無法繼續您的驗證",
  "defaultMessages.errorDetailId.govIdMismatch": "您的身份證件與您在表格中輸入的資料不符。請重試。",
  "defaultMessages.errorDetailId.govIdOtherFailure": "驗證您的身份證件時出現問題。<feedbackFormLink>請聯絡SheerID支援</feedbackFormLink>。",
  "defaultMessages.errorDetailId.govIdRetakeBiometric": "驗證您的動態捕捉時出現問題。請重試：<selfieTipsLink/>。",
  "defaultMessages.errorDetailId.govIdRetakeId": "驗證您的政府發出身份證件時出現問題。請重試：<imageTipsLink/>。",
  "defaultMessages.errorDetailId.govIdUnsupportedDoc": "不支援此文件。請使用支援的政府發出身份證件重試。",
  "defaultMessages.errorDetailId.personLimit": "您似乎已獲得此優惠的批准。",
  "defaultMessages.errorDetailId.troubleVerifying": "我們在驗證您的身份時遇到困難。<feedbackFormLink>請聯絡SheerID支援</feedbackFormLink>。",
  "defaultMessages.errorDetailId.unableToVerify": "目前無法驗證您的身份。如果您認為這是錯誤，<feedbackFormLink>請聯絡SheerID支援</feedbackFormLink>。",
  "defaultMessages.errorDetailId.vpnsNotAllowed": "此計劃不允許使用VPN。請關閉VPN後重試。如果您認為這是錯誤，<feedbackFormLink>請聯絡SheerID支援</feedbackFormLink>。",
  "defaultMessages.errorId.activeDutyStartDateBeforeBirthDate": "開始日期必須晚於出生日期",
  "defaultMessages.errorId.apiRateLimitExceeded": "目前無法處理您的請求，請稍後重試",
  "defaultMessages.errorId.dischargeDateBeforeBirthDate": "退役日期早於出生日期",
  "defaultMessages.errorId.docReviewLimitExceeded": "感謝您上載文件。我們無法以所提供的文件確認您的身份狀態。",
  "defaultMessages.errorId.duplicateFile": "部分檔案似乎相同，請選擇其他檔案。",
  "defaultMessages.errorId.expiredEmailLoopToken": "很抱歉，找不到您要求的頁面。URL可能不正確，或頁面已不再提供。",
  "defaultMessages.errorId.expiredProgram": "由於需求量極大，該優惠已不再提供。請明天再查看是否可用。",
  "defaultMessages.errorId.expiredSMSCode": "驗證碼已過期",
  "defaultMessages.errorId.expiredVerification": "此驗證已過期。請提交新的驗證。",
  "defaultMessages.errorId.failedToFetch": "HTTP請求失敗",
  "defaultMessages.errorId.fraudRulesReject": "請檢查您的資料是否正確，以及您並未使用 VPN 或其他私隱軟件。",
  "defaultMessages.errorId.futureActiveDutyStartDate": "開始日期為未來日期",
  "defaultMessages.errorId.futureBirthDate": "出生日期為未來日期",
  "defaultMessages.errorId.futureDischargeDate": "退役日期為未來日期",
  "defaultMessages.errorId.inactiveProgram": "由於需求量極大，該優惠已不再提供。請明天再查看是否可用。",
  "defaultMessages.errorId.incorrectVerificationOverrideCodeAttemptLimitExceeded": "覆蓋碼嘗試次數已超出上限",
  "defaultMessages.errorId.ineligibleOrganization": "您選擇的機構不符合此優惠的資格條件。",
  "defaultMessages.errorId.internalServerError": "內部伺服器錯誤",
  "defaultMessages.errorId.invalidActiveDutyStartDate": "無效的開始日期",
  "defaultMessages.errorId.invalidAddress": "無效的地址",
  "defaultMessages.errorId.invalidApiToken": "提供的API令牌無效或為空",
  "defaultMessages.errorId.invalidAuthenticationLoopToken": "提供的驗證碼無效",
  "defaultMessages.errorId.invalidBirthDate": "無效的出生日期",
  "defaultMessages.errorId.invalidCaptchaToken": "驗證碼驗證失敗。",
  "defaultMessages.errorId.invalidCity": "無效的城市",
  "defaultMessages.errorId.invalidCountry": "無效的國家",
  "defaultMessages.errorId.invalidCvecNumber": "無效的CVEC證書編號",
  "defaultMessages.errorId.invalidDischargeDate": "無效的退役日期",
  "defaultMessages.errorId.invalidDocUploadToken": "提供的文件上傳令牌無效",
  "defaultMessages.errorId.invalidDriverLicenseNumber": "無效的駕駛執照號碼",
  "defaultMessages.errorId.invalidEbtCardNumber": "無效的EBT卡號碼",
  "defaultMessages.errorId.invalidEmail": "無效的電郵地址",
  "defaultMessages.errorId.invalidEmailLoopToken": "很抱歉，找不到您要求的頁面。URL可能不正確，或頁面已不再提供。",
  "defaultMessages.errorId.invalidFileSizeEmpty": "一個或多個檔案為空",
  "defaultMessages.errorId.invalidFileSizeMax": "一個或多個檔案過大（最大：10MB）",
  "defaultMessages.errorId.invalidFirstName": "無效的名字",
  "defaultMessages.errorId.invalidFirstResponderStatus": "無效的緊急救援人員狀態",
  "defaultMessages.errorId.invalidLastName": "無效的姓氏",
  "defaultMessages.errorId.invalidMemberId": "無效的ID編號",
  "defaultMessages.errorId.invalidMilitaryStatus": "無效的軍人身份",
  "defaultMessages.errorId.invalidNumberOfFiles": "檔案數量超出上限（最大：5個）",
  "defaultMessages.errorId.invalidOptIn": "必須勾選才能繼續",
  "defaultMessages.errorId.invalidOrganization": "您必須從列表中選擇一個機構",
  "defaultMessages.errorId.invalidOverrideCode": "無效的覆蓋碼",
  "defaultMessages.errorId.invalidPhoneNumber": "無效的流動電話號碼",
  "defaultMessages.errorId.invalidPostalCode": "無效的郵政編碼",
  "defaultMessages.errorId.invalidProgram": "無效的計劃",
  "defaultMessages.errorId.invalidRequest": "無效的請求",
  "defaultMessages.errorId.invalidSMSCode": "無法驗證驗證碼",
  "defaultMessages.errorId.invalidSocialSecurityNumber": "無效的社會安全號碼",
  "defaultMessages.errorId.invalidState": "無效的州",
  "defaultMessages.errorId.invalidStatus": "無效的狀態",
  "defaultMessages.errorId.invalidStatuses": "無效的狀態",
  "defaultMessages.errorId.invalidStep": "無效的步驟",
  "defaultMessages.errorId.marketConsentRequired": "需要市場推廣同意",
  "defaultMessages.errorId.maxMetadataLengthExceeded": "元數據值的最大長度已超出上限",
  "defaultMessages.errorId.maxMetadataValuesExceeded": "元數據值的最大數量已超出上限",
  "defaultMessages.errorId.missingRequiredExternalId": "您必須登入才能進行驗證。請登入您的帳戶後再試。",
  "defaultMessages.errorId.missingRequiredMetadata": "您必須登入才能進行驗證。請登入您的帳戶後再試。",
  "defaultMessages.errorId.noProgram": "找不到計劃",
  "defaultMessages.errorId.noRemainingRewardCodes": "由於需求量極大，該優惠已不再提供。請明天再查看是否可用。",
  "defaultMessages.errorId.noValidFiles": "沒有有效檔案",
  "defaultMessages.errorId.noVerification": "找不到驗證",
  "defaultMessages.errorId.notApproved": "未獲批准",
  "defaultMessages.errorId.notFound": "找不到",
  "defaultMessages.errorId.outsideAgePerson": "出生日期不符合此優惠的資格條件。",
  "defaultMessages.errorId.requestTimeout": "請求逾時",
  "defaultMessages.errorId.simulatedError": "這是一個模擬錯誤",
  "defaultMessages.errorId.unauthorizedAccountStatus": "此優惠已暫時停止。請聯絡品牌的客戶支援以獲取更多資訊。",
  "defaultMessages.errorId.unauthorizedDomain": "未授權的域名",
  "defaultMessages.errorId.underagePerson": "16歲以下人士不符合此優惠的資格條件。",
  "defaultMessages.errorId.unknownError": "未知錯誤",
  "defaultMessages.errorId.unsupportedDocMimeType": "一個或多個檔案的格式不受支援",
  "defaultMessages.errorId.verificationLimitExceeded": "此優惠可能已被使用或嘗試使用。",
  "defaultMessages.experiment.step.docUpload.documentConsiderations": "文件注意事項",
  "defaultMessages.firstName": "名字",
  "defaultMessages.firstNamePlaceholder": "名字",
  "defaultMessages.firstResponderInfoShared": "此處輸入的資料將用於驗證目的。",
  "defaultMessages.footerText": "提交以上個人資料，即表示本人確認本人的個人資料正在根據本人申請折扣的商家的<privacyPolicy>私隱政策</privacyPolicy>進行收集，並且本人明白本人的個人資料將作為處理方／第三方服務供應商與SheerID共享，以便SheerID確認本人是否符合享受特別優惠的資格。<aboutSheerID>了解更多關於SheerID的資訊。</aboutSheerID>",
  "defaultMessages.footerText_sso": "繼續操作，即表示您同意將您的個人資料與 SheerID 共享，SheerID 作為您所尋求折扣的商家的處理者／第三方服務提供商。您確認，為驗證您的身份而收集的個人資料，將根據您所尋求折扣的商家的私隱政策進行處理。<aboutSheerID>了解更多關於 SheerID 的資訊。</aboutSheerID>",
  "defaultMessages.getHelp": "獲取協助",
  "defaultMessages.graduationStatus": "畢業狀態",
  "defaultMessages.howDoesReviewWork": "審核是如何進行的？",
  "defaultMessages.howDoesVerifyingWork": "驗證是如何進行的？",
  "defaultMessages.infoShared1": "按下即表示本人同意按照{privacyPolicyLink}所述，為驗證本人資格之目的處理本人的資料",
  "defaultMessages.infoShared2": "。本人明白本人的資料將與{companyName}共享。",
  "defaultMessages.informationTransferredToUS": "您的資料將被轉移至美國，並將根據SheerID的私隱政策進行處理。",
  "defaultMessages.instant": "即時",
  "defaultMessages.lastName": "姓氏",
  "defaultMessages.lastNamePlaceholder": "姓氏",
  "defaultMessages.limitExceededError": "我們無法繼續此驗證",
  "defaultMessages.loading": "載入中...",
  "defaultMessages.locales.ar": "العربية",
  "defaultMessages.locales.bg": "български",
  "defaultMessages.locales.bn-IN": "বাংলা (ভারত)",
  "defaultMessages.locales.cs": "čeština",
  "defaultMessages.locales.da": "Dansk",
  "defaultMessages.locales.de": "Deutsch",
  "defaultMessages.locales.el": "Ελληνικά",
  "defaultMessages.locales.en-GB": "English (UK)",
  "defaultMessages.locales.en-US": "English",
  "defaultMessages.locales.es": "Español",
  "defaultMessages.locales.es-ES": "Español (España)",
  "defaultMessages.locales.et": "eesti",
  "defaultMessages.locales.fa": "فارسی",
  "defaultMessages.locales.fi": "suomi",
  "defaultMessages.locales.fr": "Français",
  "defaultMessages.locales.fr-CA": "Français (Canada)",
  "defaultMessages.locales.ga": "Gaeilge",
  "defaultMessages.locales.hi-IN": "हिंदी (भारत)",
  "defaultMessages.locales.hr": "hrvatski",
  "defaultMessages.locales.hu": "magyar",
  "defaultMessages.locales.id": "Bahasa Indonesia",
  "defaultMessages.locales.is": "Íslenska",
  "defaultMessages.locales.it": "Italiano",
  "defaultMessages.locales.iw": "עברית",
  "defaultMessages.locales.ja": "日本語",
  "defaultMessages.locales.kk": "Қазақ",
  "defaultMessages.locales.ko": "한국어",
  "defaultMessages.locales.lo": "ລາວ",
  "defaultMessages.locales.lt": "Lietuvių",
  "defaultMessages.locales.lv": "Latviešu",
  "defaultMessages.locales.ms": "Bahasa Melayu",
  "defaultMessages.locales.nl": "Nederlands",
  "defaultMessages.locales.nl-BE": "Vlaams",
  "defaultMessages.locales.no": "Norsk",
  "defaultMessages.locales.pl": "Polski",
  "defaultMessages.locales.pt": "Português",
  "defaultMessages.locales.pt-BR": "Português (Brasil)",
  "defaultMessages.locales.ro": "Română",
  "defaultMessages.locales.ru": "Русский",
  "defaultMessages.locales.sk": "slovenský",
  "defaultMessages.locales.sl": "Slovenščina",
  "defaultMessages.locales.sr": "Српски",
  "defaultMessages.locales.sv": "Svenska",
  "defaultMessages.locales.sw": "Kiswahili",
  "defaultMessages.locales.ta": "தமிழ்",
  "defaultMessages.locales.th": "ไทย",
  "defaultMessages.locales.tl": "Filipino",
  "defaultMessages.locales.tr": "Türkçe",
  "defaultMessages.locales.uk": "Українська",
  "defaultMessages.locales.ur": "اردو",
  "defaultMessages.locales.vi": "Tiếng Việt",
  "defaultMessages.locales.zh": "中文（繁体）",
  "defaultMessages.locales.zh-HK": "中文（香港）",
  "defaultMessages.locales.zu": "IsiZulu",
  "defaultMessages.lowIncomeOrganization": "政府援助計劃",
  "defaultMessages.lowIncomeOrganizationPlaceholder": "政府援助計劃",
  "defaultMessages.lowRewardPool": "&#128293; 僅剩 {offersRemaining} 個優惠！",
  "defaultMessages.memberId": "身份證號碼",
  "defaultMessages.memberIdPlaceholder": "身份證號碼",
  "defaultMessages.militaryFamilyCardNote": "注意：此優惠僅適用於持有受養人身份證的軍人家屬。",
  "defaultMessages.militaryInfoShared": "此處填寫的資料將用於身份驗證。",
  "defaultMessages.militaryStatus": "軍人身份",
  "defaultMessages.multipleLocationsTips": "如果您的學術機構有多個地點，而您未找到您所屬的地點，請輸入主要地點。",
  "defaultMessages.noOptions": "沒有選項",
  "defaultMessages.openMenu": "開啟選單",
  "defaultMessages.optIn": "是的，請向我發送 {company} 的行銷通訊，包括獨家特賣、特別優惠、最新產品等資訊",
  "defaultMessages.optional": "選填",
  "defaultMessages.orgSearchSortAccessibilityLabel": "排序搜尋結果",
  "defaultMessages.orgSearchSortByDistance": "按距離排序",
  "defaultMessages.orgSearchSortByRelevance": "按相關性排序",
  "defaultMessages.organization": "機構",
  "defaultMessages.organizationPlaceholder": "機構",
  "defaultMessages.personalInformation": "個人資料",
  "defaultMessages.personalOrSchoolIsFine": "個人或學校電子郵件均可",
  "defaultMessages.phoneNumber": "手機號碼",
  "defaultMessages.phoneNumberExplanation": "選填 - 接收狀態更新的簡訊通知",
  "defaultMessages.phoneNumberWarnMessage1": "提交含手機號碼的表格，即表示您同意接收用於驗證目的的短訊/簡訊。標準電話電訊商短訊（SMS）及數據費用或適用。",
  "defaultMessages.phoneNumberWarnMessage2": "您授權您的流動服務供應商向 SheerID 披露您的手機號碼及特定帳戶資料，僅用於身份驗證及防止欺詐之目的。",
  "defaultMessages.phoneUsPlaceholder": "555-555-5555",
  "defaultMessages.postalCode": "郵政編碼",
  "defaultMessages.postalCodeExplanation": "請使用您在發牌機構備案的地址",
  "defaultMessages.postalCodePlaceholder": "郵政編碼",
  "defaultMessages.poweredBy": "驗證服務由 SheerID 提供支援",
  "defaultMessages.privacyPolicy": "私隱政策",
  "defaultMessages.proceed": "繼續",
  "defaultMessages.requestSchool": "找不到您的學校？申請新增。",
  "defaultMessages.requiredFields": "* 必填資料",
  "defaultMessages.rewardCodeEmailNotification": "我們已將副本發送至您的電子郵件，您可立即或稍後使用新代碼。請留意來自 verify@sheerid.com 的電子郵件。",
  "defaultMessages.school": "學校",
  "defaultMessages.schoolName": "學校",
  "defaultMessages.schoolNamePlaceholder": "學校",
  "defaultMessages.sheeridFaqs": "SheerID 常見問題",
  "defaultMessages.smsCodePlaceholder": "SMS 驗證碼",
  "defaultMessages.ssn": "社會安全號碼",
  "defaultMessages.ssnPlaceholder": "000-00-0000",
  "defaultMessages.state": "州",
  "defaultMessages.statePlaceholder": "州",
  "defaultMessages.states.AK": "阿拉斯加州",
  "defaultMessages.states.AL": "阿拉巴馬州",
  "defaultMessages.states.AR": "阿肯色州",
  "defaultMessages.states.AS": "美屬薩摩亞",
  "defaultMessages.states.AZ": "亞利桑那州",
  "defaultMessages.states.CA": "加利福尼亞州",
  "defaultMessages.states.CO": "科羅拉多州",
  "defaultMessages.states.CT": "康乃狄克州",
  "defaultMessages.states.DC": "哥倫比亞特區",
  "defaultMessages.states.DE": "特拉華州",
  "defaultMessages.states.FL": "佛羅里達州",
  "defaultMessages.states.GA": "喬治亞州",
  "defaultMessages.states.GU": "關島",
  "defaultMessages.states.HI": "夏威夷州",
  "defaultMessages.states.IA": "愛荷華州",
  "defaultMessages.states.ID": "愛達荷州",
  "defaultMessages.states.IL": "伊利諾伊州",
  "defaultMessages.states.IN": "印第安納州",
  "defaultMessages.states.KS": "堪薩斯州",
  "defaultMessages.states.KY": "肯塔基州",
  "defaultMessages.states.LA": "路易斯安那州",
  "defaultMessages.states.MA": "麻薩諸塞州",
  "defaultMessages.states.MD": "馬里蘭州",
  "defaultMessages.states.ME": "緬因州",
  "defaultMessages.states.MI": "密西根州",
  "defaultMessages.states.MN": "明尼蘇達州",
  "defaultMessages.states.MO": "密蘇里州",
  "defaultMessages.states.MS": "密西西比州",
  "defaultMessages.states.MT": "蒙大拿州",
  "defaultMessages.states.NC": "北卡羅來納州",
  "defaultMessages.states.ND": "北達科他州",
  "defaultMessages.states.NE": "內布拉斯加州",
  "defaultMessages.states.NH": "新罕布什爾州",
  "defaultMessages.states.NJ": "新澤西州",
  "defaultMessages.states.NM": "新墨西哥州",
  "defaultMessages.states.NV": "內華達州",
  "defaultMessages.states.NY": "紐約州",
  "defaultMessages.states.OH": "俄亥俄州",
  "defaultMessages.states.OK": "奧克拉荷馬州",
  "defaultMessages.states.OR": "俄勒岡州",
  "defaultMessages.states.PA": "賓夕法尼亞州",
  "defaultMessages.states.PR": "波多黎各",
  "defaultMessages.states.RI": "羅德島州",
  "defaultMessages.states.SC": "南卡羅來納州",
  "defaultMessages.states.SD": "南達科他州",
  "defaultMessages.states.TN": "田納西州",
  "defaultMessages.states.TX": "德克薩斯州",
  "defaultMessages.states.UT": "猶他州",
  "defaultMessages.states.VA": "維吉尼亞州",
  "defaultMessages.states.VI": "維京群島",
  "defaultMessages.states.VT": "佛蒙特州",
  "defaultMessages.states.WA": "華盛頓州",
  "defaultMessages.states.WI": "威斯康辛州",
  "defaultMessages.states.WV": "西維吉尼亞州",
  "defaultMessages.states.WY": "懷俄明州",
  "defaultMessages.status": "狀態",
  "defaultMessages.statusPlaceholder": "狀態",
  "defaultMessages.step.collectIdentifier.inputExplanation": "用於發送驗證碼",
  "defaultMessages.step.collectIdentifier.submitButton": "繼續",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdExplanation": "您的專業會籍登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdLabel": "登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerExplanation": "您的專業會籍登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerLabel": "登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberExplanation": "您的專業會籍登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberLabel": "全球位置編號",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoExplanation": "您的專業會籍登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoLabel": "登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberExplanation": "您的專業會籍登記編號",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberLabel": "登記編號",
  "defaultMessages.step.collectPersonalInfo.submitButton": "驗證我的 {segment} 狀態",
  "defaultMessages.step.collectSocialSecurityNumber.selectOption": "選擇一個選項",
  "defaultMessages.step.collectSocialSecurityNumber.title": "輸入您的社會安全號碼",
  "defaultMessages.step.collectSocialSecurityNumber.uploadDoc": "上傳文件",
  "defaultMessages.step.collectSocialSecurityNumber.uploadInstead": "改為上傳文件",
  "defaultMessages.step.collectSocialSecurityNumber.useSsn": "使用您的社會安全號碼進行驗證",
  "defaultMessages.step.completeAuthentication.manuallyVerifyButton": "手動驗證",
  "defaultMessages.step.completeAuthentication.subtitle": "輸入已發送至您電郵的驗證碼。",
  "defaultMessages.step.completeAuthentication.title": "以「記住我」進行驗證",
  "defaultMessages.step.consolation.subtitle": "雖然我們未能驗證您的身份，但 {companyName} 仍為您提供此代碼。此代碼為您專屬，且只能使用一次。",
  "defaultMessages.step.consolation.title": "領取您的優惠",
  "defaultMessages.step.consolation.verificationOnly": "如對此優惠有任何疑問，請聯絡 {companyName}。",
  "defaultMessages.step.docUpload.acceptableUploadExamples": "可接受的示例包括：",
  "defaultMessages.step.docUpload.acceptableUploads.age.birthCertificate": "出生證明",
  "defaultMessages.step.docUpload.acceptableUploads.age.driversLicense": "駕駛執照",
  "defaultMessages.step.docUpload.acceptableUploads.age.passport": "護照",
  "defaultMessages.step.docUpload.acceptableUploads.age.stateId": "州政府發出的身分證",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdContent": "根據聯邦法律，SheerID 不接受提交現役/預備役軍人身份證。",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdTitle": "請勿上傳您的軍人身份證照片。",
  "defaultMessages.step.docUpload.acceptableUploads.employment.employeeIdCard": "員工身份證",
  "defaultMessages.step.docUpload.acceptableUploads.employment.officialLetter": "一封官方信函",
  "defaultMessages.step.docUpload.acceptableUploads.employment.payStub": "最近90天內的薪資單",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.idCard": "身份證",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.letter": "官方信函",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.payStub": "最近60天內的薪資存根",
  "defaultMessages.step.docUpload.acceptableUploads.licensedProfessional.license": "執照證書",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.program": "顯示您有資格獲得所選政府援助計劃的卡片正反面。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalLetter": "由政府機構發出的所選政府援助計劃的批准函（例如，補充保障收入 (SSI) 資格函）。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalScreenshot": "所選政府援助計劃在線門戶的截圖，顯示您有資格獲得該計劃（您在線賬戶上的 Medicaid 申請狀態截圖）。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programBankStatement": "顯示所選福利最近付款的銀行對帳單。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programCard": "顯示您有資格獲得所選政府援助計劃的卡片正反面（例如，SNAP 計劃的 EBT 卡）。",
  "defaultMessages.step.docUpload.acceptableUploads.medical.idCard": "身份徽章",
  "defaultMessages.step.docUpload.acceptableUploads.medical.letterEmployment": "在過去90天內帶有公司信頭的就業證明信",
  "defaultMessages.step.docUpload.acceptableUploads.medical.licenseCertificate": "醫療執照或證書",
  "defaultMessages.step.docUpload.acceptableUploads.medical.payStub": "最近90天內的薪資存根",
  "defaultMessages.step.docUpload.acceptableUploads.medical.photoPayStub": "附照片的身份證明和近期薪資存根",
  "defaultMessages.step.docUpload.acceptableUploads.member.idCard": "會員文件",
  "defaultMessages.step.docUpload.acceptableUploads.member.payStub": "最近90天內的薪資存根",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.leaveEarningStatement": "假期和收入報表（在過去90天內注明日期）",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.uniformedServicesId": "制服服務身份證",
  "defaultMessages.step.docUpload.acceptableUploads.military.activeDuty": "任何能證明您目前在武裝部隊服現役滿30天或以上的文件",
  "defaultMessages.step.docUpload.acceptableUploads.military.dependent": "任何您在法律上可以提供的文件，以證明您是已登記的軍人家屬。",
  "defaultMessages.step.docUpload.acceptableUploads.military.goldStarFamily": "DD1300表格/傷亡報告，顯示申請人為已故者的家庭成員",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.blueUniformedId": "顯示退役狀態的制服服務身份證",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.dd214Form": "DD214 <em>(如果您服役20年以上或殘疾評定達30%或以上)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.retireeId": "退役人員身份證",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaDigitalId": "VA Digital ID <em>(如果您服役20年以上或殘疾評定達30%或以上)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaHealthBenefitsCard": "VA健康福利函（如果您的殘疾評定達30%或以上）",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.leaveEarningStatement": "假期和收入報表（在過去90天內注明日期）",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.uniformedServicesId": "制服服務身份證",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservistA": "任何顯示您目前在武裝部隊後備役部門服役的文件",
  "defaultMessages.step.docUpload.acceptableUploads.military.retiree": "任何能證明您是武裝部隊退役人員的文件",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dd214Form": "DD214表格",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.departmentVeteranId": "退伍軍人事務部身份證",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dischargeCertificate": "退役證書",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.driverLicenseVeteran": "附退伍軍人標誌的駕駛執照",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaDigitalId": "VA 數字身份",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaHealthBenefitsCard": "VA健康福利卡",
  "defaultMessages.step.docUpload.acceptableUploads.military.veteran": "任何能證明您達到軍事服役資格並光榮退伍的文件",
  "defaultMessages.step.docUpload.acceptableUploads.officialLetter": "官方信函",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.changeOfAddress": "美國郵政服務地址變更確認函",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.mortgageDeed": "抵押契約",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.rentalAgreement": "租約或租賃協議",
  "defaultMessages.step.docUpload.acceptableUploads.senior.birthCertificate": "出生證明",
  "defaultMessages.step.docUpload.acceptableUploads.senior.driversLicense": "駕駛執照",
  "defaultMessages.step.docUpload.acceptableUploads.senior.passport": "護照",
  "defaultMessages.step.docUpload.acceptableUploads.senior.stateId": "州政府發出的身分證",
  "defaultMessages.step.docUpload.acceptableUploads.student.classSchedule": "課程表",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.alumniCard": "校友／校友會會員證",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.diploma": "您的畢業證書副本",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.letterOfCompletion": "教務處開具的完成證明信",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.transcript": "正式或非正式成績單",
  "defaultMessages.step.docUpload.acceptableUploads.student.idCard": "附到期日期的學生身份證",
  "defaultMessages.step.docUpload.acceptableUploads.student.tuitionReceipt": "學費收據",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.idCard": "教育者身份證",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.payStub": "最近90天內的薪資存根",
  "defaultMessages.step.docUpload.acceptedTypes": "文件必須為 .jpg .jpeg .png .pdf",
  "defaultMessages.step.docUpload.addFile": "新增文件",
  "defaultMessages.step.docUpload.allowedDocuments": "請只上傳您依法獲准提供的文件。",
  "defaultMessages.step.docUpload.canIFinishLater": "我可以稍後完成嗎？",
  "defaultMessages.step.docUpload.canIFinishLaterDetails": "是的，如果您現在未完成，我們將自動向您提供的電子郵件地址發送一封郵件，附有返回此步驟的連結。",
  "defaultMessages.step.docUpload.documentReviewProcess": "文件將通過人工和自動文件審核的優化組合進行真實性審查，並與您提供的資料進行比對。",
  "defaultMessages.step.docUpload.documentsMustInclude": "您的文件或文件組合必須包含：",
  "defaultMessages.step.docUpload.nameChanged": "如果您的姓名在文件簽發後發生了更改，請上傳第二份顯示您正式姓名更改的文件。",
  "defaultMessages.step.docUpload.rejectedNextStep": "請更正並重試。",
  "defaultMessages.step.docUpload.rejectedSubtitle": "由於以下原因，我們無法確認您的資格：",
  "defaultMessages.step.docUpload.rejectionReasons.CUSTOM_VALUE_OTHER": "提交的文件缺少確立此優惠資格所需的要求。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_DATE_OTHER": "提交的文件不符合確立此優惠資格的日期要求。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EMAIL_SCREENSHOT": "我們無法接受電子郵件的截圖。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EXPIRED": "該文件已過期或簽發時間過早。請上傳較新的文件。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_HANDWRITTEN": "我們無法接受手寫文件。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_LIKELY_FRAUD": "該文件不足以確立此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED": "您提交的文件缺少簽發日期或簽發時間過早。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED_FACULTY": "您提交的文件無法證明您在本學年度任職。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_PASSWORD_PROTECTED": "我們無法接受受密碼保護的文件。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_STATUS_OTHER": "提交的文件顯示的狀態不足以確立此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_TOO_FUTURE": "文件中顯示的日期距離未來太遠。請上傳較新的文件以證明您的當前狀態。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNREADABLE": "由於圖像質量差，文件無法讀取。請確保您有清晰可讀、明亮清晰的圖像，並再次嘗試提交。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNSUPPORTED": "該文件不是官方文件或不在接受的文件類型列表中。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_VALID_OTHER": "提交的文件無法確立此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.EBT_CARD_NUMBER_OTHER": "提交的 EBT 卡無法確立此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_JOB_TITLE": "文件中顯示的職位名稱不符合此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_ORGANIZATION": "您提交的文件上的機構不符合此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "高中生不符合此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_CUSTOM_VALUE": "文件缺少確立您獲得此優惠資格所需的資訊。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_DOCUMENT_DATE": "文件中顯示的日期不足以證明您的當前狀態。請上傳包含近期月份和年份的文件。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_EBT_CARD_NUMBER": "上傳的 EBT 卡不足以確立此優惠的資格。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_STATUS": "該文件無法證明您具有符合此優惠資格的狀態。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_BIRTHDATE": "文件上的出生日期與您在驗證表格中輸入的出生日期不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_COMPANY_NAME_OR_ADDRESS": "您文件中的公司名稱或地址與您在驗證表格中輸入的內容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_CUSTOM_VALUE": "文件中顯示的某些信息與您在驗證表格中輸入的內容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_EBT_CARD_NUMBER": "上傳的EBT卡號與驗證表格中輸入的號碼不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION": "您提交的文件上的機構名稱與您在驗證表格中列出的機構不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_COUNTRY": "驗證表格上選擇的國家/地區與提交文件上顯示的國家/地區不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_NAME": "在驗證表格中輸入的機構名稱與提交文件中顯示的機構名稱不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_FIRST_NAME": "文件上的名字與您在驗證表格中輸入的名字不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_LAST_NAME": "在驗證表格中輸入的姓氏與提交文件上顯示的姓名不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_NAME": "您提交的文件上的信息與驗證表格上提交的姓名和/或名字不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_STATUS": "文件上的狀態與您在驗證表格中輸入的狀態不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_CUSTOM_VALUE": "文件缺少確立您此優惠資格所需的信息。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_DOCUMENT_DATE": "缺少當前日期。請上傳證明您當前狀態的官方有日期文件。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_EBT_CARD_NUMBER": "上傳的EBT卡缺少卡號。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION": "您提交的文件未提供確定此優惠資格所需的所有信息。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "您提交的文件未顯示與美國武裝部隊合格分支的關聯。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_BIRTHDATE": "您的出生日期缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_ORGANIZATION_NAME": "在驗證表格中輸入的機構名稱在提交的文件中缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_PERSON_NAME": "您提交的文件缺少名字和/或姓氏。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "您提交的文件無法證明您在本學期的入學情況。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_OR_MISMATCH_JOB_TITLE": "您提交的文件上的職稱缺失或與您在驗證表格中輸入的內容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_FIRST_NAME": "您的名字在提交的文件中缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_LAST_NAME": "您的姓氏在提交的文件中缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.ORGANIZATION_NAME_OTHER": "提交文件中顯示的機構名稱與驗證表格中提供的機構名稱不同。",
  "defaultMessages.step.docUpload.rejectionReasons.OTHER_CONTACT_US": "我們在驗證您的優惠資格時遇到問題。請聯繫SheerID客戶服務尋求幫助：customerservice@sheerid.com",
  "defaultMessages.step.docUpload.rejectionReasons.OUT_OF_RANGE_BIRTHDATE": "您的出生日期超出此優惠的可接受範圍。",
  "defaultMessages.step.docUpload.rejectionReasons.PAYSTUB_OUTDATED_LAST_30_DAYS": "請上傳在過去30天內簽發的工資單。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_BIRTHDATE_OTHER": "提交文件中顯示的出生日期與驗證表格中提供的出生日期不符。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIELD_MISMATCH": "提供文件中的某個字段與驗證表格中提供的內容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIRST_NAME_OTHER": "提交文件中顯示的名字與驗證表格中提供的名字不符。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_LAST_NAME_OTHER": "提交文件中顯示的姓氏與驗證表格中提供的姓氏不符。",
  "defaultMessages.step.docUpload.rejectionReasons.RESTRICTED_DOCUMENT": "由於法律限制，我們無法審查上傳的政府頒發身份證件。",
  "defaultMessages.step.docUpload.reviewTime": "預計審核時間為 {{estimatedReviewTime}}。",
  "defaultMessages.step.docUpload.submitButtonLabel": "提交",
  "defaultMessages.step.docUpload.suggestedDocumentTypes": "建議的文件類型",
  "defaultMessages.step.docUpload.title": "如要繼續，請上傳確認您身份的文件",
  "defaultMessages.step.docUpload.uploadInfo.affiliation": "與該組織的<strong>現時隸屬關係</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.birthDate": "<strong>出生日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.consentDE": "我同意就年齡驗證目的處理及儲存本人身份證副本。本人理解該圖像將自動儲存為副本，且本人有權在上傳前將序號塗黑。",
  "defaultMessages.step.docUpload.uploadInfo.dateCurrentYear": "目前的學年或目前的學期日期",
  "defaultMessages.step.docUpload.uploadInfo.employment.company": "<strong>您的公司</strong>",
  "defaultMessages.step.docUpload.uploadInfo.employment.currentAffiliation": "與該公司的<strong>現時隸屬關係</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.currentAffiliation": "您與該組織的現時隸屬關係",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.emt.status": "在該組織中的現時<strong>EMT狀態</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.firefighter.status": "在該組織中的現時<strong>消防員狀態</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.license": "您作為急救人員的身份或執照",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.organization": "<strong>組織</strong>名稱",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.police.status": "在該組織中的現時<strong>警察狀態</strong>",
  "defaultMessages.step.docUpload.uploadInfo.fullName": "您在此表格中填寫的<strong>全名</strong>",
  "defaultMessages.step.docUpload.uploadInfo.identity.validDate": "目前有效的日期",
  "defaultMessages.step.docUpload.uploadInfo.institutionName": "完整或縮寫的<strong>學術機構名稱</strong>或標誌",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.licenseStatus": "<strong>專業執照及/或認證狀態</strong>",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.validDate": "目前<strong>有效的日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.ebtNumber": "EBT卡號碼",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.fullName": "您的全名",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.validDate": "<strong>有效的</strong>簽發日期（最近12個月內）或有效期限（必須有效）",
  "defaultMessages.step.docUpload.uploadInfo.medical.medicalRole": "您作為<strong>醫療專業人員</strong>的角色",
  "defaultMessages.step.docUpload.uploadInfo.medical.status": "您的醫療專業人員身份",
  "defaultMessages.step.docUpload.uploadInfo.medical.validDate": "目前有效的<strong>日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.activeDuty.status": "目前<strong>現役</strong>狀態",
  "defaultMessages.step.docUpload.uploadInfo.military.currentAffiliation": "您與武裝部隊的現時隸屬關係",
  "defaultMessages.step.docUpload.uploadInfo.military.dischargeDate": "您的退役日期（如適用）",
  "defaultMessages.step.docUpload.uploadInfo.military.goldStarFamily.status": "目前<strong>軍人家屬</strong>狀態",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryFamily.status": "目前<strong>軍人家屬</strong>狀態",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryRetiree.status": "<strong>退休人員</strong>狀態",
  "defaultMessages.step.docUpload.uploadInfo.military.reservist.status": "目前<strong>後備役</strong>狀態",
  "defaultMessages.step.docUpload.uploadInfo.military.serviceBranch": "<strong>服役軍種</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsDependent": "請上傳能清楚顯示您的名字、姓氏、有效日期及身份的文件",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdContent": "根據法律，SheerID無法處理軍人身份證副本。",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdTitle": "請勿上傳您的軍人身份證照片。",
  "defaultMessages.step.docUpload.uploadInfo.military.veteran.status": "<strong>退伍軍人</strong>狀態",
  "defaultMessages.step.docUpload.uploadInfo.organization": "<strong>組織名稱</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.address": "<strong>新地址</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.validDate": "您最近搬遷的<strong>有效日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.senior.birthDate": "<strong>出生日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.student.enrollmentDate": "證明當前學期入學的日期（或最近3個月內）",
  "defaultMessages.step.docUpload.uploadInfo.student.graduate.degreeConferral": "<strong>學位頒授證明</strong>（例如「已頒授學位」狀態或畢業日期）",
  "defaultMessages.step.docUpload.uploadInfo.student.school": "您的學校",
  "defaultMessages.step.docUpload.uploadInfo.teacher.currentSchoolYear": "當前學年的日期",
  "defaultMessages.step.docUpload.uploadInfo.teacher.school": "您的學校",
  "defaultMessages.step.docUpload.whatHappensNext": "接下來會發生什麼？",
  "defaultMessages.step.docUpload.whoIsSheerId": "文件審核由SheerID負責，SheerID是專門驗證身份的可靠合作夥伴。",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.alternative": "無法存取工作電子郵件地址？",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.label": "工作電子郵件地址",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.send": "發送電子郵件",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.subtitle": "輸入您的僱主提供的電子郵件地址，我們將向您發送一個驗證連結",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.title": "使用您的工作電子郵件地址進行驗證",
  "defaultMessages.step.emailLoop.errors.invalidEmail": "此電子郵件地址不適用於即時驗證。請使用您的僱主提供的電子郵件地址，或在下方上傳文件。",
  "defaultMessages.step.emailLoop.errors.resend": "發送電子郵件時出錯",
  "defaultMessages.step.emailLoop.resendButton": "重新傳送電子郵件",
  "defaultMessages.step.emailLoop.skipEmail": "找不到電子郵件？請檢查您的垃圾郵件資料夾，或",
  "defaultMessages.step.emailLoop.skipEmail2": "電子郵件",
  "defaultMessages.step.emailLoop.skipEmailCTA": "重新傳送",
  "defaultMessages.step.emailLoop.subtitle2": "開啟 SheerID 從 (verify@sheerid.com) 傳送的電子郵件，並選擇連結以繼續。這有助於確認您可以存取該電子郵件帳戶。",
  "defaultMessages.step.emailLoop.subtitleWithEmail": "我們已將個人化連結傳送至 {email}，以繼續驗證程序。",
  "defaultMessages.step.emailLoop.subtitleWithoutEmail": "我們已將個人化連結傳送至您的電子郵件，以繼續驗證程序。",
  "defaultMessages.step.emailLoop.successResend": "電子郵件已成功重新發送。",
  "defaultMessages.step.emailLoop.title": "查看您的電子郵件",
  "defaultMessages.step.error.errorId.expiredProgram.buttonText": "查看更多優惠",
  "defaultMessages.step.error.errorId.expiredProgram.title": "優惠已售罄！",
  "defaultMessages.step.error.errorId.inactiveProgram.buttonText": "查看更多優惠",
  "defaultMessages.step.error.errorId.inactiveProgram.title": "優惠已售罄！",
  "defaultMessages.step.error.errorId.ineligibleOrganization.title": "我們無法驗證您的資格。",
  "defaultMessages.step.error.errorId.missingRequiredExternalId.title": "請登入。",
  "defaultMessages.step.error.errorId.missingRequiredMetadata.title": "請登入。",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.buttonText": "查看更多優惠",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.title": "優惠已售罄！",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.buttonText": "聯絡客服",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.title": "優惠已暫停！",
  "defaultMessages.step.error.errorId.verificationLimitExceeded.title": "驗證次數已超限",
  "defaultMessages.step.error.title": "我們無法繼續您的驗證",
  "defaultMessages.step.idCheckLoop.continue": "繼續",
  "defaultMessages.step.idCheckLoop.countrySelector.title": "簽發國家",
  "defaultMessages.step.idCheckLoop.disclaimer": "SheerID 是 {companyName} 的受信任合作夥伴，使用第三方 {serviceType} 來處理我們的身份核查。",
  "defaultMessages.step.idCheckLoop.docTypeSelector.subtitle": "您需要使用配有相機的手機或配有網路攝影機的電腦。",
  "defaultMessages.step.idCheckLoop.docTypeSelector.title": "選擇您的文件",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.subtitle": "正面和背面",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.title": "駕駛執照",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.subtitle": "正面和背面",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.title": "政府身份證",
  "defaultMessages.step.idCheckLoop.docTypes.passport.subtitle": "照片頁",
  "defaultMessages.step.idCheckLoop.docTypes.passport.title": "護照",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.subtitle": "正面和背面",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.title": "居留許可",
  "defaultMessages.step.idCheckLoop.regula.addBackImage": "新增身份證背面",
  "defaultMessages.step.idCheckLoop.regula.addFontImage": "新增身份證正面",
  "defaultMessages.step.idCheckLoop.regula.info.subtitle": "駕駛執照、州身份證、護照或居留許可。",
  "defaultMessages.step.idCheckLoop.regula.info.title": "政府簽發身份證件的照片",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityError": "圖像有質量問題。請確保圖像清晰、光線充足，所有細節均清晰可見。",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityErrorTitle": "我們無法處理您的文件",
  "defaultMessages.step.idCheckLoop.regula.sdk.rejectedImageNextStep": "請重新拍攝並再次上傳。",
  "defaultMessages.step.idCheckLoop.regula.sdk.subtitle": "提交您的政府簽發身份證件的照片以繼續驗證。",
  "defaultMessages.step.idCheckLoop.regula.sdk.title": "身份文件上傳",
  "defaultMessages.step.idCheckLoop.regula.sdk.uploadAgain": "再次上傳",
  "defaultMessages.step.idCheckLoop.regula.submit": "提交",
  "defaultMessages.step.idCheckLoop.regula.terms": "點擊「繼續」即表示您已閱讀、理解並接受 {privacyPolicyLink} 和 {termsOfService}。",
  "defaultMessages.step.idCheckLoop.regula.title": "要繼續，我們需要驗證您的身份。",
  "defaultMessages.step.idCheckLoop.regula.uploadFileError": "上傳您的文件時發生錯誤。請再試一次。",
  "defaultMessages.step.idCheckLoop.regula.uploadSubtitle": "請確保文件上的資訊清晰易讀。避免眩光。",
  "defaultMessages.step.idCheckLoop.regula.uploadTitle": "上傳政府簽發的身份證件",
  "defaultMessages.step.idCheckLoop.steps.docReview.title": "上傳身份證明文件",
  "defaultMessages.step.idCheckLoop.steps.idCheck.subtitle": "有效的政府簽發文件，例如駕駛執照、州身份證、護照或居留許可。",
  "defaultMessages.step.idCheckLoop.steps.idCheck.title": "拍攝您的政府身份證照片",
  "defaultMessages.step.idCheckLoop.steps.selfie.title": "自拍",
  "defaultMessages.step.idCheckLoop.subtitle": "您需要使用配有相機的手機或配有網路攝影機的電腦。",
  "defaultMessages.step.idCheckLoop.terms": "點擊「繼續」即表示您已閱讀、理解並接受 {scanPolicy}、{privacyPolicyLink} 和 {termsOfService}。",
  "defaultMessages.step.idCheckLoop.title": "讓我們驗證您的身份",
  "defaultMessages.step.override.errors.codeOverrideLimit": "超出覆蓋碼限制。",
  "defaultMessages.step.override.errors.invalidCode": "無效的覆蓋碼。",
  "defaultMessages.step.override.submitOverrideCodeButtonLabel": "提交覆蓋碼",
  "defaultMessages.step.override.subtitle": "若您正在店內進行驗證，但沒有證明資格的文件或難以上傳文件，請聯繫店內服務人員以確認您的資格。",
  "defaultMessages.step.override.subtitle2": "若服務人員確認您有資格享受優惠，他們可在下方輸入驗證覆蓋碼。",
  "defaultMessages.step.override.title": "無法驗證狀態",
  "defaultMessages.step.override.verificationOverrideCodeLabel": "驗證覆蓋碼",
  "defaultMessages.step.pending.idCheckLoop.subtitle": "請稍候，處理時間通常需要幾分鐘或更短。",
  "defaultMessages.step.pending.idCheckLoop.subtitle2": "審核完成後，我們將向您發送電子郵件。",
  "defaultMessages.step.pending.idCheckLoop.title": "我們正在審核您的文件",
  "defaultMessages.step.pending.subtitle": "SheerID 正在審核您的文件以確認您的狀態。此流程最多可能需要 {{maxReviewTime}}。",
  "defaultMessages.step.pending.subtitle2": "您可以在此等候或關閉此頁面。",
  "defaultMessages.step.pending.subtitle3": "審核完成後，我們會以電子郵件通知您。",
  "defaultMessages.step.pending.titleReview": "已收到文件",
  "defaultMessages.step.pending.turnaroundTime": "審核通常需時 {{estimatedReviewTime}}，但在繁忙時段可能需時最長 {{maxReviewTime}}。",
  "defaultMessages.step.personalInfo.captcha.error": "無法確認您是真人。請檢查您的網絡連接、停用廣告攔截器，或重新整理頁面後再試。",
  "defaultMessages.step.personalInfo.captcha.loading": "正在確認您是真人，請在按鈕啟用後再次點擊「{submitButtonText}」。",
  "defaultMessages.step.personalInfo.captcha.retryButton": "重試",
  "defaultMessages.step.personalInfo.captcha.success": "確認完成，請再次點擊「{submitButtonText}」以繼續驗證。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.closing": "盡情享受吧！",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.message": "Verify@sheerid.com 已重新發送您的確認電子郵件，其中包含兌換已驗證優惠的詳情。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.title": "您以前來過這裡！",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.needChanges": "需要進行更改？",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.closing": "Verify@sheerid.com 已重新發送最新電子郵件給您，其中包含後續步驟。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.message": "此電子郵件與正在進行的驗證相關聯。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.title": "看來您已開始。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.proceedHere": "在此繼續",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.closing": "Verify@sheerid.com 已重新發送最新電子郵件給您，其中包含後續步驟。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.message": "此電子郵件與正在進行的驗證相關聯，需要上傳另一份文件。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.title": "看來您已開始。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sendAgain": "重新發送",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sent": "已發送！",
  "defaultMessages.step.personalInfo.submitButtonText": "驗證並繼續",
  "defaultMessages.step.personalInfo.verifyingSubtitle": "這只需要一分鐘",
  "defaultMessages.step.personalInfo.verifyingTitle": "正在驗證您的狀態",
  "defaultMessages.step.smsLoop.errors.codeExpired": "驗證碼無法驗證。",
  "defaultMessages.step.smsLoop.errors.codeResendLimit": "已達到重試次數上限。",
  "defaultMessages.step.smsLoop.errors.codeVerification": "驗證碼無法驗證。",
  "defaultMessages.step.smsLoop.errors.resend": "發送 SMS 訊息時出錯",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber1": "號碼不正確？點擊",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber2": "這裡",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber3": "以返回 {companyName}",
  "defaultMessages.step.smsLoop.resendButton": "重新發送",
  "defaultMessages.step.smsLoop.submitButton": "提交",
  "defaultMessages.step.smsLoop.successResend": "SMS 訊息已成功重新發送",
  "defaultMessages.step.smsLoop.titleWithNumber": "我們已向以 {number} 結尾的手機號碼發送 SMS 訊息。請在此輸入您的驗證碼。",
  "defaultMessages.step.smsLoop.titleWithoutNumber": "我們已向您的手機號碼發送 SMS。請在此輸入驗證碼。",
  "defaultMessages.step.smsLoop.verificationCode": "驗證碼",
  "defaultMessages.step.sso.alternative": "您也可以透過上傳資格證明來完成驗證",
  "defaultMessages.step.sso.cancel": "上傳文件",
  "defaultMessages.step.sso.login": "登入我的學校",
  "defaultMessages.step.sso.preheader": "最快捷的方式",
  "defaultMessages.step.sso.subtitle": "請登入您學校的網頁入口。它將在新分頁中開啟。",
  "defaultMessages.step.sso.subtitle2": "無法登入？",
  "defaultMessages.step.sso.title": "使用您的學校憑證進行驗證",
  "defaultMessages.step.success.copyCouponCode": "複製優惠券代碼",
  "defaultMessages.step.success.emailNotification": "我們已向您發送了含有兌換說明的確認電郵。請查看來自 {email} 的電郵。",
  "defaultMessages.step.success.rememberMe.consumerFound.button": "儲存至「記住我」",
  "defaultMessages.step.success.rememberMe.consumerFound.description": "使用 SheerID 的「記住我」服務儲存新資料，以便享受與 {companyName} 及其他品牌的未來優惠。",
  "defaultMessages.step.success.rememberMe.consumerFound.title": "更新您的個人檔案",
  "defaultMessages.step.success.rememberMe.consumerNotFound.button": "立即登記",
  "defaultMessages.step.success.rememberMe.consumerNotFound.description": "使用 SheerID 的「記住我」服務，更快速獲取與 {companyName} 及其他品牌的未來優惠。",
  "defaultMessages.step.success.rememberMe.consumerNotFound.title": "儲存您的資料以進行一鍵驗證",
  "defaultMessages.step.success.verificationOnly": "SheerID 僅負責驗證。現在您已獲批准，請將有關推廣條款的所有問題直接聯絡 {companyName} 客戶服務。",
  "defaultMessages.step.thirdPartyLoop.error": "不支援此服務供應商",
  "defaultMessages.step.thirdPartyLoop.signzy.cancel": "上傳身份證明",
  "defaultMessages.step.thirdPartyLoop.signzy.login": "登入 DigiLocker",
  "defaultMessages.step.thirdPartyLoop.signzy.subtitle": "使用您的 DigiLocker 登入資料進行驗證",
  "defaultMessages.step.thirdPartyLoop.signzy.title": "使用 DigiLocker 進行驗證",
  "defaultMessages.streetAddress": "街道地址",
  "defaultMessages.studentInfoShared": "此處輸入的資料將用於驗證目的，並與 {companyName} 共享。",
  "defaultMessages.tryAgain": "再試一次",
  "defaultMessages.tryFullNameTips": "請嘗試輸入學術機構的完整名稱，而非使用縮寫或簡稱。",
  "defaultMessages.universityName": "大學名稱",
  "defaultMessages.verificationPurposesOnly": "僅用於驗證目的",
  "defaultMessages.verifyAndContinue": "驗證並繼續",
  "defaultMessages.verifyMyEmploymentStatus": "驗證我的僱員身份",
  "defaultMessages.verifyMyFirstResponderStatus": "驗證我的緊急救援人員身份",
  "defaultMessages.verifyMyIdentityStatus": "驗證我的身份",
  "defaultMessages.verifyMyLicensedProfessionalStatus": "驗證我的持牌專業人士身份",
  "defaultMessages.verifyMyLowIncomeStatus": "驗證我的身份",
  "defaultMessages.verifyMyMedicalProfessionalStatus": "驗證我的醫療專業人士身份",
  "defaultMessages.verifyMyMembershipStatus": "驗證我的會員資格",
  "defaultMessages.verifyMyMilitaryStatus": "驗證我的軍人身份",
  "defaultMessages.verifyMyMoverStatus": "驗證我的新搬遷者身份",
  "defaultMessages.verifyMyStudentStatus": "驗證我的學生身份",
  "defaultMessages.verifyMyTeacherStatus": "驗證我的教育工作者身份",
  "defaultMessages.warningId.openOrganization": "我們在資料庫中找不到該名稱的匹配項目。請再次確認拼寫，如果正確，請放心繼續！",
  "segmentMessages.age.emailExplanation": "建議使用個人電郵地址",
  "segmentMessages.age.step.docUpload.title": "若要繼續，請上傳確認您年齡的文件",
  "segmentMessages.age.step.docUpload.uploadInstructions": "上傳一份顯示以下內容的政府核發文件",
  "segmentMessages.age.step.docUpload.whoIsSheerId": "文件審查由 SheerID 負責，SheerID 是專門核實年齡的可信賴合作夥伴。",
  "segmentMessages.age.step.personalInfo.howDoesVerifyingWorkDetails": "要符合此優惠的資格，您必須達到特定年齡。<br><br>{{companyName}} 使用 SheerID（一個可信賴的合作夥伴）來驗證您的年齡。SheerID 僅收集有助於驗證您資格的資訊。可能會要求提供額外資訊或文件。",
  "segmentMessages.age.step.personalInfo.submitButtonText": "驗證並繼續",
  "segmentMessages.age.step.personalInfo.subtitle": "驗證您目前的年齡。",
  "segmentMessages.age.step.personalInfo.title": "解鎖您的專屬優惠",
  "segmentMessages.age.step.personalInfo.tryAgain.subtitle": "您的全名和出生日期必須與您的政府核發文件上的資訊相符。",
  "segmentMessages.age.step.personalInfo.tryAgain.title": "確認您的姓名和出生日期",
  "segmentMessages.age.step.personalInfo.verifyingTitle": "正在驗證您的年齡",
  "segmentMessages.age.step.success.redirectButtonText": "繼續",
  "segmentMessages.age.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.age.step.success.title": "您已通過驗證",
  "segmentMessages.employment.addressExplanation": "使用您的家庭地址",
  "segmentMessages.employment.emailExplanation": "如有工作電郵，請使用您的工作電郵",
  "segmentMessages.employment.step.docUpload.title": "如要繼續，請上傳確認就業狀況的文件",
  "segmentMessages.employment.step.docUpload.uploadInstructions": "上傳顯示以下內容的官方文件",
  "segmentMessages.employment.step.docUpload.whoIsSheerId": "文件審查由 SheerID 負責，SheerID 是專門驗證僱員的受信任合作夥伴。",
  "segmentMessages.employment.step.personalInfo.howDoesVerifyingWorkDetails": "{{companyName}} 為特定公司的所有現任員工設立了此特別優惠。<br><br>{{companyName}} 使用 SheerID（一個可信賴的合作夥伴）來驗證您目前是否受僱。SheerID 僅收集有助於驗證您資格的資訊。可能會要求提供額外資訊或文件。",
  "segmentMessages.employment.step.personalInfo.submitButtonText": "驗證我的員工身份",
  "segmentMessages.employment.step.personalInfo.subtitle": "確認您是符合資格公司的現任員工。",
  "segmentMessages.employment.step.personalInfo.title": "解鎖此僅限受僱人士的優惠",
  "segmentMessages.employment.step.personalInfo.tryAgain.subtitle": "您提供的資訊應與您的官方文件相符。",
  "segmentMessages.employment.step.personalInfo.tryAgain.title": "確認您所提供的資訊",
  "segmentMessages.employment.step.personalInfo.verifyingTitle": "正在驗證您的就業狀態",
  "segmentMessages.employment.step.sso.alternative": "您也可以通過上傳就業證明進行驗證",
  "segmentMessages.employment.step.sso.cancel": "上傳就業證明",
  "segmentMessages.employment.step.sso.login": "登入我的電郵",
  "segmentMessages.employment.step.sso.subtitle": "請登入您公司的電郵入口網站。它將在新分頁中開啟。",
  "segmentMessages.employment.step.sso.subtitle2": "無法登入您的電郵？",
  "segmentMessages.employment.step.sso.title": "使用公司提供的電郵憑證進行驗證",
  "segmentMessages.employment.step.success.redirectButtonText": "繼續",
  "segmentMessages.employment.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.employment.step.success.title": "您已通過驗證",
  "segmentMessages.firstResponder.emailExplanation": "如有工作電郵，請使用您的工作電郵",
  "segmentMessages.firstResponder.step.docUpload.title": "如要繼續，請上傳確認您緊急救援人員身份的文件",
  "segmentMessages.firstResponder.step.docUpload.uploadInstructions": "上傳顯示以下內容的官方文件",
  "segmentMessages.firstResponder.step.docUpload.whoIsSheerId": "文件審查由 SheerID 負責，SheerID 是專門驗證緊急救援人員的受信任合作夥伴。",
  "segmentMessages.firstResponder.step.personalInfo.howDoesVerifyingWorkDetails": "此優惠適用於所有美國緊急救援人員和應急人員，包括執法人員、急救技術員、輔助醫療人員和消防員。<br><br>{{companyName}} 使用 SheerID（一個可信賴的合作夥伴）來驗證您是否為在職緊急救援人員。SheerID 僅收集有助於驗證您資格的資訊。可能會要求提供額外資訊或文件。",
  "segmentMessages.firstResponder.step.personalInfo.submitButtonText": "驗證我的緊急救援人員身份",
  "segmentMessages.firstResponder.step.personalInfo.subtitle": "確認您是在職緊急救援人員。",
  "segmentMessages.firstResponder.step.personalInfo.title": "解鎖此僅限緊急救援人員的優惠",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.subtitle": "您的全名、組織名稱和電郵必須與您機構的記錄相符。",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.title": "確認您的姓名、電郵和組織",
  "segmentMessages.firstResponder.step.personalInfo.verifyingTitle": "正在驗證您的緊急救援人員身份",
  "segmentMessages.firstResponder.step.success.redirectButtonText": "繼續",
  "segmentMessages.firstResponder.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.firstResponder.step.success.title": "您已通過驗證",
  "segmentMessages.identity.emailExplanation": "建議使用個人電郵地址",
  "segmentMessages.identity.step.docUpload.title": "如需繼續，請上傳確認您身份狀態的文件",
  "segmentMessages.identity.step.docUpload.uploadInstructions": "上傳政府發出的文件以顯示",
  "segmentMessages.identity.step.docUpload.whoIsSheerId": "文件審查由SheerID處理，SheerID是一個專門驗證身份狀態的受信任合作夥伴。",
  "segmentMessages.identity.step.personalInfo.howDoesVerifyingWorkDetails": "要符合此優惠的資格，您必須持有有效的駕駛執照。<br><br>{{companyName}}使用受信任的合作夥伴SheerID來驗證您的身份。SheerID僅收集有助於驗證您資格的信息。可能會要求提供額外的信息或文件。",
  "segmentMessages.identity.step.personalInfo.submitButtonText": "驗證我的身份",
  "segmentMessages.identity.step.personalInfo.subtitle": "驗證您目前的身份。",
  "segmentMessages.identity.step.personalInfo.title": "解鎖您的特別優惠",
  "segmentMessages.identity.step.personalInfo.tryAgain.subtitle": "您所提供的資料必須與政府發出的文件相符。",
  "segmentMessages.identity.step.personalInfo.tryAgain.title": "檢查您的姓名和其他欄位",
  "segmentMessages.identity.step.personalInfo.verifyingTitle": "正在驗證您的身份",
  "segmentMessages.identity.step.success.redirectButtonText": "繼續",
  "segmentMessages.identity.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.identity.step.success.title": "您已通過驗證",
  "segmentMessages.licensedProfessional.emailExplanation": "如有工作電郵，請使用工作電郵",
  "segmentMessages.licensedProfessional.step.docUpload.title": "如需繼續，請上傳確認您是持牌專業人士的文件",
  "segmentMessages.licensedProfessional.step.docUpload.uploadInstructions": "上傳政府發出的文件以顯示",
  "segmentMessages.licensedProfessional.step.docUpload.whoIsSheerId": "文件審查由SheerID處理，SheerID是一個專門驗證持牌專業人士的受信任合作夥伴。",
  "segmentMessages.licensedProfessional.step.personalInfo.howDoesVerifyingWorkDetails": "要符合此優惠的資格，您必須在指定領域持有現有的專業執照。此表格的狀態選擇器中顯示了符合條件的領域。<br><br>{{companyName}}使用受信任的合作夥伴SheerID來確認您是持牌專業人士。SheerID僅收集有助於驗證您資格的信息。可能會要求提供額外的信息或文件。",
  "segmentMessages.licensedProfessional.step.personalInfo.submitButtonText": "驗證我的持牌專業人士身份",
  "segmentMessages.licensedProfessional.step.personalInfo.subtitle": "驗證您在您的領域擁有專業執照。",
  "segmentMessages.licensedProfessional.step.personalInfo.title": "解鎖此特別優惠",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.subtitle": "您所提供的資料必須與政府發出的文件相符。",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.title": "檢查您的姓名和其他欄位",
  "segmentMessages.licensedProfessional.step.personalInfo.verifyingTitle": "正在驗證您的執照",
  "segmentMessages.licensedProfessional.step.success.redirectButtonText": "繼續",
  "segmentMessages.licensedProfessional.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.licensedProfessional.step.success.title": "您已通過驗證",
  "segmentMessages.lowIncome.addressExplanation": "請使用您的住宅地址",
  "segmentMessages.lowIncome.step.docUpload.title": "如需繼續，請上傳確認您參與已批准政府援助計劃的文件",
  "segmentMessages.lowIncome.step.docUpload.uploadInstructions": "上傳顯示以下資訊的官方文件",
  "segmentMessages.lowIncome.step.docUpload.whoIsSheerId": "文件審核由 SheerID 負責，SheerID 是專門核實您資格的可信合作夥伴。",
  "segmentMessages.lowIncome.step.personalInfo.howDoesVerifyingWorkDetails": "要獲得此優惠的資格，您目前必須符合合資格政府援助計劃的條件。此優惠的合資格政府援助計劃可在下方框中找到。<br><br>{{companyName}} 使用 SheerID（一個可信合作夥伴）來核實您是這些福利的受益人。SheerID 只收集有助於核實您資格的資料。可能會要求提供其他資料或文件。",
  "segmentMessages.lowIncome.step.personalInfo.submitButtonText": "驗證我的狀態",
  "segmentMessages.lowIncome.step.personalInfo.subtitle": "驗證您符合合資格政府援助計劃的條件。",
  "segmentMessages.lowIncome.step.personalInfo.title": "解鎖此特別優惠",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.subtitle": "您所提供的資料必須與政府發出的文件相符。",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.title": "檢查您的全名和其他欄位",
  "segmentMessages.lowIncome.step.personalInfo.verifyingTitle": "正在驗證您的狀態",
  "segmentMessages.lowIncome.step.success.redirectButtonText": "繼續",
  "segmentMessages.lowIncome.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.lowIncome.step.success.title": "您已通過驗證",
  "segmentMessages.medical.emailExplanation": "如有工作電郵，請使用工作電郵",
  "segmentMessages.medical.step.docUpload.title": "如需繼續，請上傳確認您醫療專業人員身分的文件",
  "segmentMessages.medical.step.docUpload.uploadInstructions": "上傳顯示以下資訊的官方文件",
  "segmentMessages.medical.step.docUpload.whoIsSheerId": "文件審核由 SheerID 負責，SheerID 是專門核實您作為醫療專業人員資格的可信合作夥伴。",
  "segmentMessages.medical.step.personalInfo.howDoesVerifyingWorkDetails": "要獲得此優惠的資格，您必須是持牌及認證的醫療專業人員。這包括醫生、護士、藥劑師及其他醫療專業人員。<br><br>{{companyName}} 使用 SheerID（一個可信合作夥伴）來核實您的醫療專業人員身分。SheerID 只收集有助於核實您資格的資料。可能會要求提供其他資料或文件。",
  "segmentMessages.medical.step.personalInfo.submitButtonText": "驗證我的醫療專業人員狀態",
  "segmentMessages.medical.step.personalInfo.subtitle": "驗證您作為持牌醫療專業人員的身分。",
  "segmentMessages.medical.step.personalInfo.title": "解鎖此專屬醫療專業人員優惠",
  "segmentMessages.medical.step.personalInfo.tryAgain.subtitle": "您的姓名、出生日期和機構必須與我們的記錄相符",
  "segmentMessages.medical.step.personalInfo.tryAgain.title": "請確認您的姓名、出生日期和機構正確無誤",
  "segmentMessages.medical.step.personalInfo.verifyingTitle": "正在驗證您的醫療專業人員狀態",
  "segmentMessages.medical.step.sso.alternative": "您也可以透過雇主入口網站進行驗證",
  "segmentMessages.medical.step.sso.login": "登入雇主入口網站",
  "segmentMessages.medical.step.sso.subtitle": "使用您機構的憑證來驗證您的狀態",
  "segmentMessages.medical.step.sso.title": "驗證醫療保健專業人員狀態",
  "segmentMessages.medical.step.success.redirectButtonText": "繼續",
  "segmentMessages.medical.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.medical.step.success.title": "您已通過驗證",
  "segmentMessages.member.step.docUpload.title": "如需繼續，請上傳確認您在合資格組織中的會籍的文件",
  "segmentMessages.member.step.docUpload.uploadInstructions": "上傳顯示以下資訊的官方文件",
  "segmentMessages.member.step.docUpload.whoIsSheerId": "文件審核由 SheerID 負責，SheerID 是專門核實您作為會員資格的可信合作夥伴。",
  "segmentMessages.member.step.personalInfo.howDoesVerifyingWorkDetails": "要獲得此優惠的資格，您必須是合資格組織的有效會員。此優惠的合資格組織可在下方框中找到。<br><br>{{companyName}} 使用 SheerID（一個可信合作夥伴）來核實您的會員資格。SheerID 只收集有助於核實您資格的資料。可能會要求提供其他資料或文件。",
  "segmentMessages.member.step.personalInfo.submitButtonText": "驗證我的會員狀態",
  "segmentMessages.member.step.personalInfo.subtitle": "驗證您在合資格組織中的有效會籍。",
  "segmentMessages.member.step.personalInfo.title": "解鎖此專屬會員優惠",
  "segmentMessages.member.step.personalInfo.tryAgain.subtitle": "您的資料必須與組織的官方記錄相符",
  "segmentMessages.member.step.personalInfo.tryAgain.title": "請確認所提供的資訊正確無誤",
  "segmentMessages.member.step.personalInfo.verifyingTitle": "正在驗證您的會員資格",
  "segmentMessages.member.step.success.redirectButtonText": "繼續",
  "segmentMessages.member.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.member.step.success.title": "您已通過驗證",
  "segmentMessages.military.emailExplanation": "建議使用個人電郵地址",
  "segmentMessages.military.step.docUpload.title": "如需繼續，請上傳確認您軍事身分的文件",
  "segmentMessages.military.step.docUpload.uploadInstructions": "上傳您的政府發出文件以顯示",
  "segmentMessages.military.step.docUpload.whoIsSheerId": "文件審核由 SheerID 負責，SheerID 是專門核實您作為軍人資格的可信合作夥伴。",
  "segmentMessages.military.step.personalInfo.howDoesVerifyingWorkDetails": "要獲得此優惠的資格，您必須是現役、退役或退伍軍人。這包括現役軍人、後備軍人、退伍軍人及其家屬。<br><br>{{companyName}} 使用 SheerID（一個可信合作夥伴）來核實您的軍事身分。SheerID 只收集有助於核實您資格的資料。可能會要求提供其他資料或文件。",
  "segmentMessages.military.step.personalInfo.submitButtonText": "驗證我的軍事狀態",
  "segmentMessages.military.step.personalInfo.subtitle": "驗證您作為現役、退役或退伍軍人的身分。",
  "segmentMessages.military.step.personalInfo.title": "解鎖此專屬軍人優惠",
  "segmentMessages.military.step.personalInfo.tryAgain.subtitle": "請確認您的姓名、出生日期和軍種正確無誤",
  "segmentMessages.military.step.personalInfo.tryAgain.title": "檢查您的姓名和出生日期",
  "segmentMessages.military.step.personalInfo.verifyingTitle": "正在驗證您的軍事狀態",
  "segmentMessages.military.step.success.redirectButtonText": "繼續",
  "segmentMessages.military.step.success.subtitle": "您現在有資格享受此特別優惠。",
  "segmentMessages.military.step.success.title": "您已通過驗證",
  "segmentMessages.recentMover.emailExplanation": "建議使用個人電郵地址",
  "segmentMessages.recentMover.step.docUpload.title": "如需繼續，請上傳確認您最近搬遷的文件",
  "segmentMessages.recentMover.step.docUpload.uploadInstructions": "請上傳顯示以下內容的官方文件",
  "segmentMessages.recentMover.step.docUpload.whoIsSheerId": "文件審查由SheerID負責，SheerID是專門核實近期搬遷者的可信賴合作夥伴。",
  "segmentMessages.recentMover.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此優惠的資格，您必須在過去60天內搬遷至新地址。<br><br>{{companyName}}使用SheerID（值得信賴的合作夥伴）驗證您是否最近已搬遷。SheerID僅收集有助於驗證您資格的資訊。可能會要求提供其他資訊或文件。",
  "segmentMessages.recentMover.step.personalInfo.submitButtonText": "驗證我的新搬遷狀態",
  "segmentMessages.recentMover.step.personalInfo.subtitle": "驗證您最近已搬遷。",
  "segmentMessages.recentMover.step.personalInfo.title": "解鎖此特別優惠",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.subtitle": "您的名字、姓氏及地址必須與您的正式文件上的內容相符。",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.title": "確認您的姓名及地址資料",
  "segmentMessages.recentMover.step.personalInfo.verifyingTitle": "正在驗證您的搬遷狀態",
  "segmentMessages.recentMover.step.success.redirectButtonText": "繼續",
  "segmentMessages.recentMover.step.success.subtitle": "您現在符合此特別優惠的資格。",
  "segmentMessages.recentMover.step.success.title": "您已通過驗證",
  "segmentMessages.senior.emailExplanation": "建議使用個人電郵地址",
  "segmentMessages.senior.step.docUpload.title": "如需繼續，請上傳確認您年齡的文件",
  "segmentMessages.senior.step.docUpload.uploadInstructions": "請上傳政府發出的文件，顯示",
  "segmentMessages.senior.step.docUpload.whoIsSheerId": "文件審查由SheerID負責，SheerID是專門核實年齡的可信賴合作夥伴。",
  "segmentMessages.senior.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此優惠的資格，您必須達到特定年齡。<br><br>{{companyName}}使用SheerID（值得信賴的合作夥伴）驗證您的年齡。SheerID僅收集有助於驗證您資格的資訊。可能會要求提供其他資訊或文件。",
  "segmentMessages.senior.step.personalInfo.submitButtonText": "驗證並繼續",
  "segmentMessages.senior.step.personalInfo.subtitle": "驗證您目前的年齡。",
  "segmentMessages.senior.step.personalInfo.title": "解鎖您的特別優惠",
  "segmentMessages.senior.step.personalInfo.tryAgain.subtitle": "您的全名及出生日期必須與您的政府發出文件上的內容相符。",
  "segmentMessages.senior.step.personalInfo.tryAgain.title": "確認您的姓名及出生日期",
  "segmentMessages.senior.step.personalInfo.verifyingTitle": "正在驗證您的年齡",
  "segmentMessages.senior.step.success.redirectButtonText": "繼續",
  "segmentMessages.senior.step.success.subtitle": "您現在符合此特別優惠的資格。",
  "segmentMessages.senior.step.success.title": "您已通過驗證",
  "segmentMessages.student.emailExplanation": "建議使用學生電郵地址",
  "segmentMessages.student.schoolName": "學校",
  "segmentMessages.student.step.docUpload.title": "若要繼續，請上載一份或多份確認您學生身份的文件。",
  "segmentMessages.student.step.docUpload.uploadInstructions": "請上傳您學校發出的文件，顯示",
  "segmentMessages.student.step.docUpload.whoIsSheerId": "文件審查由SheerID負責，SheerID是專門核實學生身份的可信賴合作夥伴。",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.alternative": "無法使用學術電郵地址？",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.email.label": "學術電郵地址",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.subtitle": "輸入您的學術機構提供的電郵地址，我們將向您發送驗證連結",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.title": "使用您的學術電郵地址驗證",
  "segmentMessages.student.step.emailLoop.errors.invalidEmail": "此電郵地址不適用於即時驗證。請使用您的學術機構提供的電郵地址或在下方上傳文件。",
  "segmentMessages.student.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此優惠的資格，您必須目前在具學位或證書頒授資格的認可教育學校就讀。<br><br>{{companyName}}使用SheerID（值得信賴的合作夥伴）驗證您是現役學生。SheerID僅收集有助於驗證您資格的資訊。可能會要求提供其他資訊或文件。",
  "segmentMessages.student.step.personalInfo.submitButtonText": "驗證我的學生身份",
  "segmentMessages.student.step.personalInfo.subtitle": "驗證您是頒授學位學校的學生。",
  "segmentMessages.student.step.personalInfo.title": "解鎖此學生專屬優惠",
  "segmentMessages.student.step.personalInfo.tryAgain.subtitle": "您的全名及出生日期必須與您的官方學校記錄相符。",
  "segmentMessages.student.step.personalInfo.tryAgain.title": "確認您的姓名及出生日期",
  "segmentMessages.student.step.personalInfo.verifyingTitle": "正在驗證您的學生身份",
  "segmentMessages.student.step.sso.alternative": "您也可以透過上傳入學證明來驗證",
  "segmentMessages.student.step.sso.cancel": "上傳入學證明",
  "segmentMessages.student.step.sso.login": "登入我的學術機構",
  "segmentMessages.student.step.sso.subtitle": "登入您的學術機構以驗證您目前的註冊狀態。您的學校入口網站將在新視窗中開啟。",
  "segmentMessages.student.step.sso.title": "使用您的學校登入資料進行驗證",
  "segmentMessages.student.step.success.redirectButtonText": "繼續",
  "segmentMessages.student.step.success.subtitle": "您現在符合此特別優惠的資格。",
  "segmentMessages.student.step.success.title": "您已通過驗證",
  "segmentMessages.teacher.emailExplanation": "必須是您學校發出的電郵地址",
  "segmentMessages.teacher.schoolName": "學校名稱",
  "segmentMessages.teacher.schoolNamePlaceholder": "學校名稱",
  "segmentMessages.teacher.step.docUpload.title": "如需繼續，請上傳確認您教育工作者身份的文件",
  "segmentMessages.teacher.step.docUpload.uploadInstructions": "請上傳您學校發出的文件，顯示",
  "segmentMessages.teacher.step.docUpload.whoIsSheerId": "文件審查由SheerID負責，SheerID是專門核實教育工作者身份的可信賴合作夥伴。",
  "segmentMessages.teacher.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此優惠的資格，您必須目前在認可教育機構擔任教育工作者、教職員或員工。<br><br>{{companyName}}使用SheerID（值得信賴的合作夥伴）驗證您是現任教育工作者、教職員或員工。SheerID僅收集有助於驗證您資格的資訊。可能會要求提供其他資訊或文件。",
  "segmentMessages.teacher.step.personalInfo.submitButtonText": "驗證我的教育工作者身份",
  "segmentMessages.teacher.step.personalInfo.subtitle": "驗證您是認可教育機構的教育工作者、教職員或員工。",
  "segmentMessages.teacher.step.personalInfo.title": "解鎖此教育工作者專屬優惠",
  "segmentMessages.teacher.step.personalInfo.tryAgain.subtitle": "您的全名及電郵地址必須與您學校記錄的內容相符。",
  "segmentMessages.teacher.step.personalInfo.tryAgain.title": "確認您的姓名及電郵",
  "segmentMessages.teacher.step.personalInfo.verifyingTitle": "正在驗證您的教育工作者身份",
  "segmentMessages.teacher.step.success.redirectButtonText": "繼續",
  "segmentMessages.teacher.step.success.subtitle": "您現在符合此特別優惠的資格。",
  "segmentMessages.teacher.step.success.title": "您已通過驗證",
  "segmentMessages.student.step.personalInfo.nameInstructions": "請準確輸入您在正式學校紀錄上顯示的姓名。",
  "segmentMessages.student.step.docUpload.uploadInfo.fullName": "您在學校紀錄上顯示的<strong>全名</strong>",
  "defaultMessages.step.pending.uploadedDocument": "您的文件已成功上載，正在審核中。",
  "defaultMessages.step.docUpload.uploadInfo.expiration": "尚未過期的到期日",
  "defaultMessages.step.docUpload.uploadInfo.issueDate": "過去 90 天內的簽發日期",
  "defaultMessages.step.docUpload.uploadInfo.enrollmentProof": "<strong>目前註冊</strong>的證明，以下列其中一項顯示：",
  "defaultMessages.contactSupport": "如果您認為自己符合資格，請查看我們的<faqLink>協助中心</faqLink>或<feedbackFormLink>聯絡 SheerID 支援團隊</feedbackFormLink>"
}
